// extracted by mini-css-extract-plugin
export default {"card":"card-qJsGVhGp","narrow":"narrow-M60RL5cq"};